/**
 * Legal notices shown at domain checkout (register + transfer-in).
 * Add a ccTLD registry: one entry in REGISTRY_TERMS. Labels are English i18n keys (t()).
 */
export const REGISTRY_TERMS = {
    dk: { label: 'Punktum dk terms', url: 'https://punktum.dk/en/articles/terms-and-conditions-dk-domain-name' },
    se: { label: 'Internetstiftelsen terms', url: 'https://internetstiftelsen.se/en/how-to-register-a-domain-name/terms-and-conditions-for-se-and-nu-domains/' },
    nu: { label: 'Internetstiftelsen terms', url: 'https://internetstiftelsen.se/en/how-to-register-a-domain-name/terms-and-conditions-for-se-and-nu-domains/' },
};

export const ICANN_TRANSFER_POLICY = {
    label: 'ICANN Transfer Policy',
    url: 'https://www.icann.org/resources/pages/transfer-policy-2016-06-01-en',
};

// gTLD = ICANN Transfer Policy applies. ccTLDs are 2-letter TLDs (incl. second levels like .co.uk / .com.br).
export const isGenericTld = (domain) => {
    const tld = String(domain || '').toLowerCase().replace(/\.$/, '').split('.').pop();
    return !!tld && !/^[a-z]{2}$/.test(tld);
};

/** Notices for a set of domains, de-duplicated: [{ key, sentence, label, url }] */
export const checkoutNotices = (domains = []) => {
    const out = new Map();
    domains.forEach((d) => {
        const tld = String(d || '').toLowerCase().replace(/\.$/, '').split('.').pop();
        const reg = REGISTRY_TERMS[tld];
        if (reg && !out.has(reg.url)) {
            out.set(reg.url, { key: reg.url, sentence: 'By registering, you agree to the {{registry}}.', ...reg });
        } else if (isGenericTld(d) && !out.has(ICANN_TRANSFER_POLICY.url)) {
            out.set(ICANN_TRANSFER_POLICY.url, { key: ICANN_TRANSFER_POLICY.url, sentence: 'You authorize us to act as your Designated Agent for registrant changes.', ...ICANN_TRANSFER_POLICY });
        }
    });
    return [...out.values()];
};
